import React from 'react';
import ReactDOM from 'react-dom';
import { AppParma } from './AppParma';

ReactDOM.render(
    <AppParma />,
  document.getElementById('root')
);
